import _ from "lodash";

import { FilterDefinitionType } from "@/components/@types";
import { Typography } from "@/components/ui/typography";

type OperatorType = FilterDefinitionType["operators"][number];

export function FilterOperatorRow({ operator }: { operator: OperatorType }) {
  return (
    <div
      data-testid={`filter-operator-row-${operator.name}`}
      className="flex flex-wrap items-center gap-2 pl-1 min-w-100"
    >
      <Typography level="body-md">{_.capitalize(operator.name)}</Typography>
      <div className="grow" />
      {operator.symbol && (
        <Typography
          level="body-xs"
          className="[border-width:1px] [border-style:solid] border-border text-muted-foreground/80 pl-1 pr-1 pb-px text-center rounded"
        >
          {operator.symbol}
        </Typography>
      )}
    </div>
  );
}
